import type {ReactNode} from 'react';
import React from 'react';
import Head from 'next/head';
import {Box} from '@tempo/core';

type Props = {
	children?: ReactNode;
	title?: string;
};

const Layout: React.FC<Props> = ({children, title = 'My Deezer Year'}) => (
	<>
		<Head>
			{/* TODO Fix title */}
			<title>{title}</title>
			<meta charSet="utf-8" />
			<meta
				name="viewport"
				content="initial-scale=1.0, width=device-width, viewport-fit=cover"
			/>
		</Head>
		<Box className="layout-box">{children}</Box>
	</>
);

export default Layout;
